import { isNullOrUndefined, isObject } from '~/util/validators/baseComponentsValidators'

export default {
  inserted(el, binding) {
    // Extract size and color from binding value with defaults
    const show = isNullOrUndefined(binding.value.show) ? true : !!binding.value.show
    const size = binding.value.size || '8px'
    const color = binding.value.color || 'var(--red-500)'
    const position
      = (isObject(binding.value.position) && Object.keys(binding.value.position).length > 0)
        ? binding.value.position
        : { top: 0, right: 0 }

    const style = binding.value.style || {}
    // Create the red dot element
    const dot = document.createElement('span')
    dot.classList.add('v-badge')
    // Apply css positioning, i.e., left top right bottom
    Object.keys(position).forEach(key => {
      const allowedKeys = ['top', 'left', 'right', 'bottom']
      if (allowedKeys.includes(key)) dot.style[key] = position[key]
    })
    dot.style.width = size
    dot.style.height = size
    dot.style.backgroundColor = color

    Object.keys(style).forEach(styleProp => {
      dot.style[styleProp] = style[styleProp]
    })
    // Position the parent element as relative if it doesn't have any specified already
    const oldPos = el.style.position
    if (!oldPos) el.style.position = 'relative'

    if (!show) dot.classList.add('hidden')

    // Append the dot to the element
    el.appendChild(dot)

  },
  update(el, binding) {
    // Old variant
    // let dot = document.querySelector('.v-badge')

    // New variant
    let dot = el.querySelector('.v-badge')
    const show = isNullOrUndefined(binding.value.show) ? true : !!binding.value.show
    if (!show && !!dot) {
      dot.classList.add('hidden')
      return
    }

    const style = binding.value.style || {}
    const size = binding.value.size || '8px'
    const color = binding.value.color || 'var(--red-500)'
    const position
      = (isObject(binding.value.position) && Object.keys(binding.value.position).length > 0)
        ? binding.value.position
        : { top: 0, right: 0 }

    if (show && !!!dot) {
      dot = document.createElement('span')
      dot.classList.add('v-badge')
      Object.keys(position).forEach(key => {
        const allowedKeys = ['top', 'left', 'right', 'bottom']
        if (allowedKeys.includes(key)) dot.style[key] = position[key]
      })
      dot.style.width = size
      dot.style.height = size
      dot.style.backgroundColor = color
      Object.keys(style).forEach(styleProp => {
        dot.style[styleProp] = style[styleProp]
      })

      // Position the parent element as relative
      const oldPos = el.style.position
      if (!oldPos) el.style.position = 'relative'

      el.appendChild(dot)
    }
    if (show && !!dot) {
      dot.classList.remove('hidden')
      dot.style.width = size
      dot.style.height = size
      dot.style.backgroundColor = color
      Object.keys(position).forEach(key => {
        const allowedKeys = ['top', 'left', 'right', 'bottom']
        if (allowedKeys.includes(key)) dot.style[key] = position[key]
      })

      Object.keys(style).forEach(styleProp => {
        dot.style[styleProp] = style[styleProp]
      })
    }
  },
}
